import Vue from 'vue'

export default {
    notify(title, text, type) {
        const NotificationTypes = ["warn", "success", "error"]
        if (!NotificationTypes.includes(type)) return
        Vue.notify({
            group: 'error',
            title: title,
            text: text,
            type: type
          });
    }
}